import { lego } from '@zz-common/lego'
import { url } from '@zz-yp/hunter-js-utils'
const busPath = '/u/'
const projectName = 'hunter-market'

const getPageType = (toPath) => {
  let routerPath = projectName + '/index'
  if (toPath) {
    routerPath = projectName + (toPath === '/' ? '' : toPath)
  } else {
    const mt = location.pathname.split(busPath)
    if (mt && mt.length == 2) {
      routerPath = mt[1]
    }
  }
  return routerPath.replace(/\//g, '_')
}

let globalBackup = {}
let pagetype = getPageType() || 'hunter_market'

const initLegoData = (param = {}) => {
  globalBackup = param.backup || {}
  pagetype = getPageType(param.routerPath)
}

const legic = (page, actiontype, backup) => {
  globalBackup.channel = url.getParam('channel')
  lego.send({
    pagetype: page || pagetype,
    actiontype,
    backup: Object.assign({}, globalBackup, backup)
  })
}

export { initLegoData, legic }
